import LegalPage, { H3, P, List } from "./LegalLayout";

export default function Terms() {
  return (
    <LegalPage
      kicker="Terms of Use"
      title="The terms of this room."
      effectiveDate="February 2026"
    >
      <P>
        These Terms of Use govern your access to and use of the Maven Skies
        website and any related programs presented here, including Maven Skies
        Angels and Groundwork. By using the site, you agree to these Terms. If
        you do not agree, please do not use the site.
      </P>

      <H3>Nothing here is investment advice</H3>
      <P>
        The information on this site is provided for general informational
        purposes only. It is not, and should not be construed as, an offer to
        sell or a solicitation of an offer to buy any security, investment
        product, or service. Nothing on this site constitutes legal, tax,
        accounting, or investment advice. You should consult qualified
        professional advisors before making any investment decision.
      </P>

      <H3>Not an offering of securities</H3>
      <P>
        Maven Skies is not a broker-dealer, exempt market dealer, or registered
        adviser. Any offering of securities in which Maven Skies or its
        affiliates are involved will be made only pursuant to definitive
        offering documents and only to eligible investors under applicable
        Canadian securities laws (including, where applicable, National
        Instrument 45-106). Membership in Maven Skies Angels does not itself
        constitute an offer of securities.
      </P>

      <H3>Angel investing carries risk</H3>
      <P>
        Early-stage private company investments are speculative, illiquid, and
        involve substantial risk, including the potential loss of the entire
        amount invested. Past performance is not indicative of future results.
        Any decision to invest is made solely by you, at your own risk.
      </P>

      <H3>Eligibility and membership</H3>
      <List
        items={[
          "Access to Maven Skies Angels and related programs is by invitation and subject to eligibility review.",
          "Members are expected to meet all applicable securities-law investor requirements (such as accredited investor status where relevant) at the time of any investment they choose to make.",
          "Membership does not create any partnership, joint venture, or fiduciary relationship between you and Maven Skies.",
        ]}
      />

      <H3>Confidentiality</H3>
      <P>
        Information shared through Maven Skies programs, including founder
        materials, deal documents, member commentary, and diligence, is
        confidential. You agree to treat such information as such and not to
        disclose it outside the group without the applicable owner&apos;s
        consent.
      </P>

      <H3>Referrals and curation</H3>
      <P>
        Companies reach the network by direct application or by referral from
        trusted members and venture partners. A referral reflects the referring
        party&apos;s judgment; it is not a recommendation by Maven Skies.
        Every opportunity that reaches the group passes through the same
        diligence standard before being shared, but neither Maven Skies nor
        its partners guarantee any outcome or the accuracy of information
        provided by founders.
      </P>

      <H3>Intellectual property</H3>
      <P>
        The Maven Skies name, logos, wordmarks, program names (including
        Groundwork), and the design and content of this site are owned by
        Maven Skies Inc. or its licensors. You may not reproduce, distribute,
        or create derivative works from this site or its content without our
        prior written consent, except as permitted by law.
      </P>

      <H3>User conduct</H3>
      <P>
        You agree to use the site lawfully and respectfully. You will not
        attempt to gain unauthorized access, interfere with the site&apos;s
        operation, or misuse any information obtained through the site or its
        programs.
      </P>

      <H3>Third-party links</H3>
      <P>
        The site may reference or link to third-party sites. We do not control
        and are not responsible for the content, policies, or practices of
        third parties.
      </P>

      <H3>Disclaimer of warranties</H3>
      <P>
        The site and its content are provided &ldquo;as is&rdquo; and
        &ldquo;as available.&rdquo; To the fullest extent permitted by law,
        Maven Skies disclaims all warranties, express or implied, including
        warranties of merchantability, fitness for a particular purpose, and
        non-infringement.
      </P>

      <H3>Limitation of liability</H3>
      <P>
        To the fullest extent permitted by law, Maven Skies and its officers,
        directors, employees, contractors, and partners will not be liable for
        any indirect, incidental, special, consequential, or punitive damages
        arising out of your use of the site, its programs, or any information
        obtained through them.
      </P>

      <H3>Governing law</H3>
      <P>
        These Terms are governed by the laws of the Province of Saskatchewan
        and the federal laws of Canada applicable therein. Disputes will be
        resolved in the courts of Saskatchewan.
      </P>

      <H3>Changes</H3>
      <P>
        We may revise these Terms from time to time. Continued use of the site
        after changes are posted constitutes acceptance of the revised Terms.
      </P>

      <H3>Contact</H3>
      <P>
        Maven Skies Inc., Saskatchewan, Canada:{" "}
        <a className="underline" style={{ color: "#e9d6a2" }} href="mailto:danielle@mavenskies.ca">
          danielle@mavenskies.ca
        </a>
        .
      </P>
    </LegalPage>
  );
}
